/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDUserCoverageInformation' store object.
 * @namespace SDUserCoverageInformationSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDUserCoverageInformation';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDUserCoverageInformationSelectors
   */
  static fetchSdExternalUserCoverageInfo = state =>
    state[selectors.moduleIdentifier].fetchSdExternalUserCoverageInfo.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDUserCoverageInformationSelectors
   */
  static isFetchingFetchSdExternalUserCoverageInfo = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdExternalUserCoverageInfo.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDUserCoverageInformationSelectors
   */
  static fetchSdExternalUserCoverageInfoError = state =>
    state[selectors.moduleIdentifier].fetchSdExternalUserCoverageInfoError.payload;
}
